import store from '../../../store/store';
import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { mcpCredentialsUrl, resolveMcpAuth } from './mcp-auth';
import { submitLogToBugsnag } from '../log';
import { formatMcpCredentials } from './mcp-credentials-payload';

export default async function connect_mcp_api_call(
  mcpId: number,
  credentials: any,
  oauthCode?: string
) {
  try {
    const shopSlug = store.getState().user?.company?.shop_slug;
    const auth = resolveMcpAuth();

    const requestInfo: RequestInfo = {
      url: mcpCredentialsUrl(auth, shopSlug),
      method: 'POST',
      body: JSON.stringify({
        tara_mcp_id: mcpId,
        credentials: formatMcpCredentials(credentials),
        oauth_code: oauthCode,
      }),
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        Authorization: auth.authorization,
      },
    };

    const actionType = 'ADD_MCP_CONNECTION';
    const customMsg = 'Integration Connection Successful.';

    const res: any = await asyncHandler(
      requestInfo,
      actionType,
      customMsg,
      true,
      false,
      // shouldShowErrorMsg: surface the backend's error body (e.g. Shopify's
      // 400 "Connection failed…" when the live Admin API check rejects the
      // token) — 422 validation errors were already surfaced, but plain
      // success:false responses were silently swallowed before.
      true,
      false,
      ['You have reached the maximum number of credentials for the free tier']
    );

    const response = res.data;

    if (res.actionType === actionType) {
      return response;
    } else {
      return {};
    }
  } catch (exception) {
    console.log('Error during authentication request');
    submitLogToBugsnag('error', `${exception}`);
    return false;
  }
}
